import useGetReportsFromApi from 'features/reportDetails/utils/useGetReportsFromApi'
import { Outlet, useParams } from 'react-router-dom'

const FetchReportFromApiProvider = () => {
  const { id } = useParams() as { id: string }
  useGetReportsFromApi(id)
  return <Outlet />
}
export default FetchReportFromApiProvider
